import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginForm } from '../components/LoginForm';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';

export const LoginPage: React.FC = () => {
  const [loginError, setLoginError] = useState<string>('');
  const { theme, toggleTheme } = useTheme();
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleLogin = (username: string, password: string) => {
    if (username === 'admin' && password === 'admin') {
      localStorage.setItem('isAuthenticated', 'true');
      setLoginError('');
      navigate('/dashboard');
    } else {
      setLoginError(t('login.error'));
    }
  };

  console.log('LoginPage render - window width:', window.innerWidth);

  return (
    <LoginForm
      onLogin={handleLogin}
      error={loginError}
      theme={theme}
      onToggleTheme={toggleTheme}
    />
  );
};
